import React from 'react';
import { Provider } from 'react-redux';
import store from '../../state';

import ContractCompliance from '../dashboards/widgets/ContractCompliance/ContractCompliance';
import DashboardAPIManager from '../dashboards/DashboardAPIManager';

// Non-dashboard version of the ContractCompliance widget. This is displayed on
// the contracts page for the user. This is needed because the plain widget
// cannot be embedded directly. It needs a reference to a store.
// The widget does not support custom period type, if one is provided, fallback
// to a year. Remove once support for custom period type has been added
//
//
// Since the component is used outside the dashboards, a new instance of the API Manager is
// needed
const PersonalContractCompliance = props => (
  <Provider store={store}>
    <ContractCompliance {...props} dashboardAPIManager={new DashboardAPIManager()} />
  </Provider>
);

export default PersonalContractCompliance;
